import { Home } from '../../components/Home/Home'

export const HomeContainer = ({ setIsIntersecting, isIntersecting }) => {
    return <Home setIsIntersecting={setIsIntersecting} isIntersecting={isIntersecting}/>
}